import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/lib/auth";
import ThemeToggle from "@/components/ThemeToggle";
import BrandLogo from "@/components/BrandLogo";

/**
 * Shared header for all public pages (Landing, HowItWorks, Honnetete, Tarifs).
 * - Logo: scrolls to top if on `/`, else navigates to `/`.
 * - Nav links use Router for separate pages.
 */
export default function PublicHeader() {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useAuth();

    const onLogoClick = (e) => {
        e.preventDefault();
        if (location.pathname === "/accueil" || location.pathname === "/") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            navigate("/accueil");
        }
    };

    const navItems = [
        { to: "/comment-ca-marche", label: "Comment ça marche" },
        { to: "/honnetete", label: "Honnêteté" },
        { to: "/tarifs", label: "Tarifs" },
    ];

    return (
        <header className="fixed top-0 inset-x-0 z-50 tk-glass">
            <div className="max-w-6xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
                <Link
                    to="/accueil"
                    onClick={onLogoClick}
                    className="flex items-center gap-2"
                    data-testid="header-logo"
                    aria-label="Retour à l'accueil"
                >
                    <BrandLogo height={48} />
                </Link>
                <nav className="hidden sm:flex items-center gap-6 text-sm">
                    {navItems.map((n) => {
                        const active = location.pathname === n.to;
                        return (
                            <Link
                                key={n.to}
                                to={n.to}
                                data-testid={`nav-${n.to.replace("/", "")}`}
                                className={`transition ${active ? "text-[#007AFF] font-semibold" : "text-[#1D1D1F] hover:opacity-70"}`}
                            >
                                {n.label}
                            </Link>
                        );
                    })}
                </nav>
                <div className="flex items-center gap-2">
                    <ThemeToggle />
                    {user ? (
                        <Link
                            to="/app"
                            className="tk-btn tk-btn-primary text-sm"
                            data-testid="header-open-app-btn"
                        >
                            Ouvrir l'app <ArrowRight className="w-4 h-4" />
                        </Link>
                    ) : (
                        <>
                            <Link to="/login" className="tk-btn tk-btn-ghost text-sm" data-testid="header-login-btn">
                                Connexion
                            </Link>
                            <Link to="/register" className="tk-btn tk-btn-primary text-sm" data-testid="header-register-btn">
                                Essayer gratuitement
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
